const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_cognito_identity_pool_id: 'us-east-1:e86a3ca8-d9d6-4875-ace2-350121b3c523',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_dtM3uB4Wj',
  aws_user_pools_web_client_id: '6tnhljd18qasbcebpon1r13j2m',
  oauth: {},
};

export default awsmobile;
